import { render, staticRenderFns } from "./GymSuspensionBtn.vue?vue&type=template&id=5f67f152&"
import script from "./GymSuspensionBtn.vue?vue&type=script&lang=js&"
export * from "./GymSuspensionBtn.vue?vue&type=script&lang=js&"
import style0 from "./GymSuspensionBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports